import { toast as sonnerToast, Toaster as SonnerToaster } from "sonner";
import { ToastUI } from "./toast-ui";
import type { ToastVariant } from "./types";

interface ToastOptions {
  description?: string;
  duration?: number;
}

export function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
  return <SonnerToaster offset={16} mobileOffset={24} {...props} />;
}

function showToast(
  variant: ToastVariant,
  title: string,
  options: ToastOptions = {},
) {
  sonnerToast.custom(
    (id) => (
      <ToastUI
        id={id}
        title={title}
        description={options.description}
        variant={variant}
      />
    ),
    {
      duration: options.duration ?? 5000,
    },
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const toast = {
  success: (title: string, options?: ToastOptions) =>
    showToast("success", title, options),

  error: (title: string, options?: ToastOptions) =>
    showToast("error", title, options),

  information: (title: string, options?: ToastOptions) =>
    showToast("information", title, options),
};
